import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLink = () => {
  return (
    <g>
      <path d="m8.25 11.0693-2.6753 2.6758a2.4111 2.4111 0 0 1 -3.3193 0 2.35 2.35 0 0 1 0-3.3193l2.6757-2.6758a2.3509 2.3509 0 0 1 3.3193 0 .75.75 0 0 0 1.0606-1.0605 3.8512 3.8512 0 0 0 -5.44 0l-2.6762 2.6757a3.847 3.847 0 0 0 5.44 5.44l2.6762-2.6752a.75.75 0 1 0 -1.061-1.0607z" />
      <path d="m14.8052 1.1963a3.8512 3.8512 0 0 0 -5.44 0l-2.6772 2.6758a.75.75 0 0 0 1.0605 1.0605l2.6768-2.6758a2.3471 2.3471 0 0 1 3.3193 3.3193l-2.6767 2.6759a2.3518 2.3518 0 0 1 -3.3193 0 .75.75 0 0 0 -1.0606 1.0605 3.8512 3.8512 0 0 0 5.44 0l2.6768-2.6758a3.853 3.853 0 0 0 .0004-5.4404z" />
    </g>
  );
};

export default withIcon(IconLink);
